import React, { useLayoutEffect, useRef } from "react";

import * as d3 from "d3";

import { generateLabelProgression } from "src/organization/pages/project/environment/metrics/http/helper";
import { PositionType } from "src/organization/pages/project/environment/metrics/http/types";

type RulerProps = {
  ticksCount: number;
  yScale?: d3.ScaleLinear<number, any>;
  xScale?: d3.ScaleBand<Date>;
  id: string;
  steps?: number;
  position: PositionType;
  max?: number;
  transform?: string;
};

const Ruler = (props: RulerProps) => {
  const rulerRef = useRef<SVGGElement>(null);
  const { ticksCount, yScale, id, position, max, transform } = props;
  const ticks = yScale?.ticks();
  const yTicks = yScale?.ticks(ticksCount);
  const stepUnit = (yTicks?.[1] || 0) / 2;

  useLayoutEffect(() => {
    const ruler = d3.select(rulerRef.current);
    const progression = generateLabelProgression(ticksCount, max);
    const stroke = "var(--icon-periwinkle-grey-fill,var(--periwinkle-grey))";
    ruler
      .selectAll("line")
      .data(progression)
      .join("line")
      .attr("x1", position.xRangeStart)
      .attr("x2", position.xRangeEnd)
      .attr("y1", d => yScale?.(d))
      .attr("y2", d => yScale?.(d))
      .attr("stroke", stroke)
      .attr("stroke-width", 0.5)
      .attr("opacity", 0.4);
  }, [position, stepUnit, yTicks, ticksCount, yScale, ticks, max]);

  return (
    <g
      ref={rulerRef}
      id={`${id}-ruler`}
      className="ruler-container"
      transform={transform}
    />
  );
};

export default Ruler;
